import { api } from "./client";

export async function voteComment(comment_id: number, value: 1 | -1 | 0) {
  return api("/comment-vote", "POST", { comment_id, value }, true);
}

export async function getMyCommentVotes() {
  return api<Record<string, number>>("/my-comment-votes", "GET", undefined, true);
}
